/* CommitMessageVeilComponent.js */

"use strict";

const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CommitMessageVeilComponent extends BaseCreateComponent {
    constructor(logger, message) {
        super(logger, "Commit and Push", message, "", "", "Confirm");
    }
}

module.exports = CommitMessageVeilComponent;
